// Error monitoring (Sentry). Off unless REACT_APP_SENTRY_DSN is set at build
// time, so local dev sends nothing. No PII: Sentry's default user/IP capture is
// disabled and no session replay is recorded.
import * as Sentry from '@sentry/react';

const DSN = process.env.REACT_APP_SENTRY_DSN;

export function initSentry() {
  if (!DSN) return false;
  Sentry.init({
    dsn: DSN,
    environment: process.env.REACT_APP_ENVIRONMENT || 'development',
    release: process.env.REACT_APP_RELEASE || undefined,
    sendDefaultPii: false,
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0),
  });
  return true;
}

// Report an error caught by our own boundary (React doesn't rethrow it).
export function reportError(error, componentStack) {
  if (!DSN) return;
  Sentry.captureException(error, { contexts: { react: { componentStack } } });
}
